import { createApi } from '@reduxjs/toolkit/query/react';

import { PawtripWidgetDetailsResponse } from '@/types/Dashboard';
import { ResponseError } from '@/types/Error';
import { PawtripDetailsResponse, PawtripPeriodListResponse } from '@/types/Pawtrip';
import { SuccessResponse } from '@/types/Success';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

const applicationJson = 'application/json';

export const pawtripApi = createApi({
  reducerPath: 'pawtripApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: 'pawtrip' }),
  tagTypes: ['PawtripWidget'],
  endpoints: builder => ({
    getPawtripWidgetDetails: builder.query<SuccessResponse<PawtripWidgetDetailsResponse>, void>({
      query: () => ({
        url: `/GetPawtripWidgetDetails`,
        method: 'GET',
        headers: { 'Content-Type': applicationJson },
      }),
      transformResponse: (response: SuccessResponse<PawtripWidgetDetailsResponse>) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
    petPawtripPeriodList: builder.query<SuccessResponse<PawtripPeriodListResponse>, void>({
      query: () => ({
        url: '/GetPawtripPeriods',
        method: 'GET',
        headers: { 'Content-Type': applicationJson },
      }),

      transformResponse: (response: SuccessResponse<PawtripPeriodListResponse>) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
    petPawtripDetails: builder.query<SuccessResponse<PawtripDetailsResponse>, { periodId: string }>({
      query: ({ periodId }) => ({
        url: `/GetPawtripReport?periodId=${periodId}`,
        method: 'GET',
        headers: { 'Content-Type': applicationJson },
      }),

      transformResponse: (response: SuccessResponse<PawtripDetailsResponse>) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
  }),
});

export const { usePetPawtripPeriodListQuery, usePetPawtripDetailsQuery, useGetPawtripWidgetDetailsQuery } = pawtripApi;
